import { BLOOD_SUGAR_PATTERN } from "../resource/regexp-patterns";
import { warningMessageType } from "../resource/warning-message-type";

export function valueIsNumber(value) {
  return !!value.match(BLOOD_SUGAR_PATTERN);
}

export function valueInRanage(value, min, max) {
  return min <= value && value <= max;
}

export function setWarning(label, input, button, warningMessage) {
  input.classList.add("input_field_warning");
  label.classList.add("label_title_warning");
  input.classList.remove("input_field_passed");
  label.classList.remove("label_title_passed");

  button.disabled = true;
  warningMessage.type = warningMessageType.text;
}

export function removeWarning(label, input, button, warningMessage) {
  input.classList.remove("input_field_warning");
  label.classList.remove("label_title_warning");
  input.classList.add("input_field_passed");
  label.classList.add("label_title_passed");

  button.disabled = false;
  warningMessage.type = warningMessageType.hidden;
}
